import { BackendModel, BackendService } from "../../../core/backend.service";

export class ProductosBuscados extends BackendModel {

    static path:string = '/productos/';
    id:number;
     description:string;


  constructor(protected backendService: BackendService, model?: ProductosBuscados) {
      super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/carga-masiva/categoria-producto-add-massive/productosBuscados.models.ts